import React, {  } from 'react';

import { timeFormatOptions } from '../types';
import { DateTimeFormatInput, DatTimeFormatRuleSet } from './Intl.DateTimeFormat';
import { IntlFunction } from './Intl.Function';

export const DateToLocaleTimeString = () => (
	<IntlFunction
		input={DateTimeFormatInput}
		mdnLink="https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toLocaleTimeString"
		header="Date.prototype.toLocaleTimeString"
		description={`
Returns a string with a language-sensitive representation of the time portion of the date. The newer **\`locales\`** and **\`options\`** arguments let applications specify the language formatting conventions to use. These arguments can also customize the behavior of the function.

More dated implementations ignore the **\`locales\`** and **\`options\`** arguments. In these circumstances, the form of the string returned is entirely implementation-dependent.`}
		options={timeFormatOptions}
		ruleSet={DatTimeFormatRuleSet}
		template="##input:raw##.toLocaleTimeString(##locale##, ##options##)" />
)